export default __webpack_public_path__ + "static/media/design-img_mobile.ed77da47.png";